// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IsFunction<T, R, Fallback = T> = T extends (...args: any[]) => any ? R : Fallback;
export type IsObject<T, R, Fallback = T> = IsFunction<T, Fallback, T extends object ? R : Fallback>;
export type Tail<S> = S extends `${string}.${infer T}` ? Tail<T> : S;
export type Value<T> = T[keyof T];

export type Flatten<ObjectType> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${Flatten<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

export type FlattenType<T, K extends Flatten<T> | string> = K extends `${infer A}.${infer B}`
  ? A extends keyof T
    ? FlattenType<T[A], B>
    : never
  : K extends keyof T
    ? T[K]
    : never;

export function assertUnreachable(value: never): never {
  throw new Error(`Unexpected value: ${value}`);
}
